import { render, staticRenderFns } from "./LiftRecord.vue?vue&type=template&id=390f81c0"
import script from "./LiftRecord.vue?vue&type=script&lang=js"
export * from "./LiftRecord.vue?vue&type=script&lang=js"
import style0 from "./LiftRecord.vue?vue&type=style&index=0&id=390f81c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports